module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-activities.26f94730.jpg";